import { baseTheme } from '@src/theme';
import { Breadcrumb } from 'antd';
import { styled } from 'styled-components';

export const StyledBreadcrumb = styled(Breadcrumb)`
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: ${(props) =>
        props.theme?.colors?.secondary?.main?.text ||
        baseTheme.colors.secondary.main.text};

    ol {
        align-items: center;
    }

    .breadcrumb-item {
        display: flex;
        align-items: center;
        gap: 4px;

        &.breadcrumb-item-link {
            .breadcrumb-link {
                height: unset;
                color: ${(props) =>
                    props.theme?.colors?.primary?.main?.filled ||
                    baseTheme.colors.primary.main.filled};
                text-decoration: none;

                &:hover {
                    background-color: ${(props) =>
                        props.theme?.colors?.primary?.light?.surfaceBg ||
                        baseTheme.colors.primary.light.surfaceBg};
                    text-decoration: none;
                    color: ${(props) =>
                        props.theme?.colors?.primary?.main?.hover ||
                        baseTheme.colors.primary.main.hover};
                }
            }
        }

        &.breadcrumb-item-last {
            color: ${(props) =>
                props.theme?.colors?.secondary?.light?.text ||
                baseTheme.colors.secondary.light.text};
        }
    }

    .ant-breadcrumb-separator {
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }
`;

export const StyledInfoIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: ${(props) =>
        props.theme?.colors?.info?.light?.surfaceBg ||
        baseTheme.colors.info.light.surfaceBg};
    padding: 4px;
    border-radius: 4px;

    svg {
        width: 12px;
        height: 12px;
        color: ${(props) =>
            props.theme?.colors?.info?.main?.icon ||
            baseTheme.colors.info.main.icon};
    }
`;
